import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PropertiesService } from 'src/app/properties/service/properties.service';

import { listProperties, removeCaracter } from '../../../../core/constants/properties-const';

import { fieldsTypeUnit } from '../../../../core/constants/fields-type-unit';

@Component({
  selector: 'app-capture-unit-product-modal',
  templateUrl: 'capture-unit-product-modal.component.html',
  styleUrls: ['./capture-unit-product-modal.component.scss']
})
export class CaptureUnitProductModalComponent implements OnInit {


  public closeDropDown = false;
  public returnForm = false;

  public listImoveis = listProperties;
  public dataValue = null;
  public titleList: string;
  public code: number;
  public form: FormGroup;
  public removeCaracter = removeCaracter;

  public fields = {
    useful_area: { show: false, required: false },
    total_area: { show: false, required: false },
    manufacturing_area: { show: false, required: false },
    carpet_area: { show: false, required: false },
    patio_area: { show: false, required: false },
    right_foot: { show: false, required: false },
    bedroom: { show: false, required: false },
    suite: { show: false, required: false },
    bathroom: { show: false, required: false },
    car_spaces: { show: false, required: false },
    living_room: { show: false, required: false },
    kitchen_pantry: { show: false, required: false },
    kitchen: { show: false, required: false },
    docks: { show: false, required: false },
    mezzanine: { show: false, required: false },
    number_floors: { show: false, required: false }
  };

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<CaptureUnitProductModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit(): void {
    this.unitForm();
    if (this.data.type) {
      this.assigningValue(this.data.type);
    }
  }


  // 88050150
  public unitForm(): void {
    this.form = this.formBuilder.group({
      id: this.data.unit?.id ? this.data.unit?.id : [null],
      typeCode: this.data.unit?.typeCode ? this.data.unit?.typeCode : [null],
      commercial: this.data.unit?.commercial ? this.data.unit?.commercial : false,
      residential: this.data.unit?.residential ? this.data.unit?.residential : false,
      useful_area: this.data.unit?.useful_area ? this.data.unit?.useful_area : [null],
      total_area: this.data.unit?.total_area ? this.data.unit?.total_area : [null],
      manufacturing_area: this.data.unit?.manufacturing_area ? this.data.unit?.manufacturing_area : [null],
      carpet_area: this.data.unit?.carpet_area ? this.data.unit?.carpet_area : [null],
      patio_area: this.data.unit?.patio_area ? this.data.unit?.patio_area : [null],
      right_foot: this.data.unit?.right_foot ? this.data.unit?.right_foot : [null],
      bedroom: this.data.unit?.bedroom ? this.data.unit?.bedroom : [null],
      suite: this.data.unit?.suite ? this.data.unit?.suite : [null],
      bathroom: this.data.unit?.bathroom ? this.data.unit?.bathroom : [null],
      car_spaces: this.data.unit?.car_spaces ? this.data.unit?.car_spaces : [null],
      living_room: this.data.unit?.living_room ? this.data.unit?.living_room : [null],
      kitchen_pantry: this.data.unit?.kitchen_pantry ? this.data.unit?.kitchen_pantry : [null],
      kitchen: this.data.unit?.kitchen ? this.data.unit?.kitchen : [null],
      docks: this.data.unit?.docks ? this.data.unit?.docks : [null],
      mezzanine: this.data.unit?.mezzanine ? this.data.unit?.mezzanine : [null],
      number_floors: this.data.unit?.number_floors ? this.data.unit?.number_floors : [null],
    });
  }

  public sendingDataForm(): void {
    Object.keys(this.form.controls).forEach((x: string) => {
      if (this.form.get(x).value === '' || this.form.get(x).value === null) {
        this.validFormNotRequired(x);
        this.verificationFieldValid(x);
      }
    });
    if (!this.form.get('commercial').value && !this.form.get('residential').value) {
      this.form.get('residential').setErrors({required: true});
      this.form.get('commercial').setErrors({required: true});
    } else {
      this.form.get('residential').setErrors(null);
      this.form.get('commercial').setErrors(null);
    }
    if (this.form.valid) {
      localStorage.setItem('form', JSON.stringify(this.form.value));
      this.dialogRef.close(this.form);
    }
  }

  private verificationFieldValid(x: string) {
    const listType = [3, 28, 30, 31, 32, 21, 34, 2, 26, 27, 29, 33, 35, 17, 36, 8, 7, 19, 5, 38, 40, 41, 42, 44, 39, 4, 43, 23];
    if (listType.find(type => type === this.form.get('typeCode').value)) {
      const fieldsToValidation = Object.keys(this.fields).map((fieldName: string) => {
        if (this.fields[fieldName].required) { return fieldName; }
      });
      this.applicationValidatorField(fieldsToValidation.filter(Boolean), x);
    } else {
      this.applicationValidatorField(['typeCode'], x);
    }
  }

  private applicationValidatorField(list: string[], compared: string) {
    if (list.length) {
      list.forEach(x => {
        if (compared === x) {
          this.form.get(x).setErrors({ required: false });
        }
      });
    }
  }

  private validFormNotRequired(x: string): void {
    if (x === 'state' || x === 'city') {
      this.form.get(x).setErrors({ required: false });
    }
  }

  public assigningValue(data: any): void {
    this.titleList = data.item;
    this.closeDropDown = false;
    this.code = data.code;
    this.form.get('typeCode').setValue(data.code);
    const validationForms = fieldsTypeUnit.find(form => form.typeId === data.code);
    validationForms.fields.forEach(field => {
      this.fields[field.name].show = field.show;
      this.fields[field.name].required = field.required;
    });
  }

}
